import {
	BaseError,
} from './BaseError';

export class PostDuplicateOffersError extends BaseError {
	constructor(message: string, stack?: string) {
		super(message, stack);
	}
}
